import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const FooterEl = styled.footer`
  
  display: flex;
  justify-content: center;
  padding: 20px 0 200px 0;
`;

const FooterContainer = styled.div`
  max-width: 1090px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLogoImg = styled.img`
  max-width: 266px;
  width: 100%;
  height: auto;
`;

const FooterLogo = () => {
  return (
    <Link to="/">
      <FooterLogoImg src="logo.png" />
    </Link>
  );
};

const SocialMediaIcon = ({ to, src, alt }) => {
  return (
    <a href={to}>
      <img src={src} alt={alt} />
    </a>
  );
};

const SocialMediaIconList = styled.ul`
  list-style: none;
  display: flex;
  margin: 20px 0;

  li {
    margin-right: 20px;

    a {
      img {
        max-width: 24px;
        width: 100%;
        height: auto;
      }
    }
  }
`;

const SocialMediaIcons = () => {
  return (
    <SocialMediaIconList>
      {/* <li>
      
        <SocialMediaIcon
          to="https://twitter.com/TheRealCUES"
          src="icn-social-twitter.png"
          alt="Twitter icon"
        />
      </li>
      <li>
        <SocialMediaIcon
          to="https://www.facebook.com/therealcues"
          src="icn-social-facebook.png"
          alt="Facebook icon"
        />
      </li> */}
      <li>
        <SocialMediaIcon
          to="https://www.linkedin.com/company/cues_2"
          src="icn-social-linkedin.png"
          alt="LinkedIn icon"
        />
      </li>
      <li>
        <SocialMediaIcon
          to="https://www.youtube.com/channel/UCo4yp6tkYO6Oa_Q9ONbJFEg"
          src="icn-social-youtube.png"
          alt="youtube icon"
        />
      </li>
    </SocialMediaIconList>
  );
};

const FooterNavContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding-top: 20px;
  margin-bottom: 20px;
   &::before {
    content: '';
    position: absolute;
    top: 0; /* Adjust if you want it somewhere else */
    left: 0;
    width: 100%;
    height: 1px; /* Border height */
    background: linear-gradient(
      45deg,       /* Angle of the gradient */
      #2D66AC 0%,  /* First color stop at 0% */
      #009CA3 50%, /* Second color stop at 50% */
      #AED6B8 100% /* Third color stop at 100% */
    );
  }
  ul {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      li {
          &:not(:last-child) {
              margin-right: 20px;
          }

          a {
              color: #000;
              text-decoration: none;
          }
      }
  }
`;

const FooterNav = () => {
  return (
    <FooterNavContainer>
      <ul>
        <li>
          <a href="https://www.cues.org/event-cancellation-policy" target="_blank" rel="noreferrer">Event Cancellation Policy</a>
        </li>
        <li>
          <a href="https://www.cues.org/cues-bylaws" target="_blank" rel="noreferrer">CUES Bylaws</a>
        </li>
        <li>
          <a href="https://www.cues.org/terms-and-conditions-use" target="_blank" rel="noreferrer">Terms & Conditions</a>
        </li>
        <li>
          <a href="https://www.cues.org/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>
        </li>
        <li>
          <a href="https://www.cues.org/accessibility-statement" target="_blank" rel="noreferrer">Accessibility Statement</a>
        </li>
        <li>
          <a href="https://www.cues.org/sitemap" target="_blank" rel="noreferrer">Sitemap</a>
        </li>
      </ul>
    </FooterNavContainer>
  );
};

const Copyright = styled.p`
    color: #000;
`

const Footer = () => {
  return (
    <FooterEl>
      <FooterContainer>
        <FooterLogo />
        <SocialMediaIcons />
        <FooterNav />
        <Copyright>© 2022 Credit Union Executives Society</Copyright>
      </FooterContainer>
    </FooterEl>
  );
};

export default Footer;
